<template>
  <div class="Reports__View">
      <template v-if="isLoading">
        <div class="loading">
          <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false" />
        </div>
      </template>
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>יחידות לימוד</template>
      <template #button>
        <div style="display: flex; align-items: center; gap: 10px;">
          <a @click="addLesson" class="link-button">
            הוספת יחידת לימוד לקורס
          </a>
          <a @click="reOrderLessons" class="button-close">
            סדר יחידות לימוד מחדש
          </a>
        </div>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import CoursesService from "@/services/CoursesService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import LessonEntity from "@/views/LessonEntity.vue";
import DialogAddLesson from '@/components/DialogAddLesson.vue';
import TableActions from "@/services/TableActionsService";
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";
import FilterService from "@/services/FilterService";
import LessonService from "../services/LessonService";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
      isLoading: false
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    courseId() {
      return this.$store.state.auth.course.id;
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const lessonsFields = FieldService.list("lessons");
      const reportsfilters = FilterService.list();

      const sideViewEntity = {
        component: LessonEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי יחידת לימוד",
        recordUrl: "lessons",
        recordTitle: "הצג יחידת לימוד"
      };
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.CourseNumber, checked: true },
        { ...lessonsFields.LessonName, checked: true },
        { ...lessonsFields.LessonColor, checked: true },
        { ...lessonsFields.DefaultExerciseCategoryId, checked: true },
        { ...lessonsFields.LessonType, checked: true },
        { ...lessonsFields.Status, checked: true },
        { ...lessonsFields.SortOrder, checked: true },
        { ...lessonsFields.IsHidden, checked: true },
        { ...lessonsFields.Entity, checked: true },
      ];

      this.tabs = [
        {
          id: "AllLessons",
          isPrimary: true,
          title: "כל יחידות הלימוד",
          getDataAsync: this.getAllLessons,
          perPage: 500,
          fields,
          filters: [
            { ...reportsfilters.Groups, selected: this.$route.params.GroupIds },
            { ...reportsfilters.LessonTypes },
          ],
          sortField: "sortOrder",
          sortOrder: "desc",
          checkableRows: true,
          tableActions: [
            TableActions.setLessonColor,
            TableActions.setLessonStatus,
            TableActions.setLessonHidden,
            TableActions.archiveLessons,
          ],
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש יחידת לימוד",
          },
          sideViewEntity,
        },
        {
          id: "ActivatedLessons",
          isPrimary: false,
          title: "פעילים בלבד",
          getDataAsync: this.getActivatedLessons,
          perPage: 100,
          fields,
          filters: [
            { ...reportsfilters.Groups, selected: this.$route.params.GroupIds },
          ],
          sortField: "DateTaken",
          sortOrder: "desc",
          fastSearch: true,
          tableActions: [
            TableActions.setLessonColor,
            TableActions.setLessonStatus,
            TableActions.setLessonHidden,
            TableActions.archiveLessons,
          ],
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש יחידת לימוד",
          },
          checkableRows: true,
          sideViewEntity,
        },
        {
          id: "ArchivedLessons",
          isPrimary: false,
          title: "ארכיון",
          getDataAsync: this.getArchivedLessons,
          perPage: 100,
          fields,
          filters: [
            { ...reportsfilters.Groups, selected: this.$route.params.GroupIds },
          ],
          sortField: "DateTaken",
          sortOrder: "desc",
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש יחידת לימוד",
          },
          tableActions: [
            TableActions.setLessonColor,
            TableActions.setLessonStatus,
            TableActions.setLessonHidden,
            TableActions.unArchiveLessons,
          ],
          checkableRows: true,
          // sideViewEntity,
        },
      ];
    },
    addLesson() {
      Modal.open({
        component: DialogAddLesson,
        props: {
          reportNumbers: [{ Id: 1, reportNumber: 123 }, { Id: 2, reportNumber: 3456 }],
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    reOrderLessons() {
      this.isLoading = true;
      LessonService.organizeLessons(this.tabs[0].items)
      .then(() => {
        this.$refs.entity.onNewEntitySave(this.tabs[0].items);
          // this.isLoading = false;
        }).finally(() => {
          this.isLoading = false;
        })
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllLessons({ cancelToken, ...rest }) {
      return CoursesService.getCourse(
        this.courseId,
        {
          ...rest,
        },
        false,
        cancelToken.token
      ).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getActivatedLessons({ cancelToken, ...rest }) {
      return CoursesService.getCourse(
        this.courseId,
        {
          ...rest,
        },
        true,
        cancelToken.token
      ).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getArchivedLessons({ cancelToken, ...rest }) {
      return CoursesService.getCourse(
        this.courseId,
        {
          ...rest,
          IsArchived: true
        },
        false,
        cancelToken.token
      ).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
  },
};
</script>
<style scoped lang="scss">
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}

.button-close {
  background: white;
  color: #00427e;
  border: none;
  border: 1px solid #00427e;
  padding: 13px 30px;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
}
</style>
